<template>
  <ubi-page-container wide-main-content>
    <ubi-panel>
      <h1>{{ $t("socialNetworkPosts.title") }}</h1>
      <div style="margin-left: 5%; margin-right: 5%; font-size: 130%;">
        <p class="text-justify">{{ $t("socialNetworkPosts.text1") }}</p>
        <ul>
          <li><p class="text-justify">{{ $t("socialNetworkPosts.text2") }}</p></li>
          <li><p class="text-justify">{{ $t("socialNetworkPosts.text3") }}</p></li>
          <li><p class="text-justify">{{ $t("socialNetworkPosts.text4") }}</p></li>
          <li><p class="text-justify">{{ $t("socialNetworkPosts.text5") }}</p></li>
          <li><p class="text-justify">{{ $t("socialNetworkPosts.text6") }}</p></li>
        </ul>
        <strong>{{ $t("socialNetworkPosts.text7") }}</strong>
        <br><br><br>
        <el-row>
          <el-col :lg="8" style="text-align: center">
            <img
            alt=""
            :src="require(`@/assets/1200px-Google-My-Business_logo.svg.png`)"
            width="115"
            />
          </el-col>
          <el-col :lg="8" style="text-align: center">
            <img
                alt=""
                :src="require(`@/assets/facebook-logo-5-1.png`)"
                width="115"
            />
          </el-col>
          <el-col :lg="8" style="text-align: center">
            <img
                alt=""
                :src="require(`@/assets/2048px-Instagram_icon.png`)"
                width="115"
            />
          </el-col>
        </el-row>
      </div>
      <br><br><br><br>
      <div class="text-center">
        <el-row>
          <el-button v-if="!isSubUser" @click="send">{{ $t("socialNetworkPosts.beContacted") }}</el-button>
        </el-row>
        <br/>
        <el-row>
            <router-link :to="{ name: 'posts' }">
              <el-button type="primary">
              {{ $t("socialNetworkPosts.alreadyClient") }}
              </el-button>
            </router-link>
        </el-row>
      </div>
    </ubi-panel>
  </ubi-page-container>
</template>

<script>
import { sendEmail } from '@/services/email'
import { mapGetters } from 'vuex'
import UbiPageContainer from '@/components/PageContainer.vue'
import UbiPanel from '@/components/Panel.vue'

export default {
  name: 'Presence',
  components: { UbiPanel, UbiPageContainer },
  data () {
    return {
      sendTo: null
    }
  },
  computed: {
    ...mapGetters(['isSubUser']),
    ...mapGetters('productLine', ['hasLocalSeo']),
    user () {
      return this.$store.getters.getUser
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    }
  },
  methods: {
    eventAnalytics (category) {
      this.$ga.event('socialNetworkPosts', 'clic', category, this.sitimmoUser.id)
    },
    async send () {
      this.$ga.event('socialNetworkPosts', 'clic', 'etre_recontacte', this.sitimmoUser.id)
      this.loading = true
      this.sendTo = processEnvConfig.VUE_APP_ADRESSE_MAIL_CONTACT_PRODUIT_RESEAUX_SOCIAUX
      const mailData = {
        to: this.sendTo,
        subject: this.$t('socialNetworkPosts.emailSubject', { advertiser: this.user.advertiser }),
        email_content: this.$t('socialNetworkPosts.emailContent', { advertiser: this.user.advertiser, companyName: this.sitimmoUser.nom, email: this.sitimmoUser.email, phoneNumber: this.sitimmoUser.telephone })
      }
      const response = await sendEmail(mailData)
      if (response.type == 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        this.loading = false
        return false
      }
      window.alert(this.$t('socialNetworkPosts.dialogMessage'))
      this.loading = false
    }
  }
}
</script>

<style>
#lienBouton1{
  color: grey;
  text-decoration: none;
}
#lienBouton2{
  color: white;
  text-decoration: none;
}
</style>
